import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth } from "../../../api";
import { useAuth } from "../../../hooks";
import { initialValues, validationSchema } from "./LoginForm.form";
import { toast, ToastContainer } from "react-toastify";

const authController = new Auth();

export function LoginForm() {
  const { login } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await authController.login(formValue);
        //guardamos los tokens en las constantes
        authController.setAccessToken(response.access); //llamamos a la funcion setAccessToken y le pasamos el token
        authController.setRefreshToken(response.refresh); //llamamos a la funcion setRefreshToken y le pasamos el token
        login(response.access); //llamamos a la funcion login y le pasamos el token
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false, // Para que el usuario tenga que cerrarlo manualmente
          closeOnClick: true,
        });
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          type="text"
          icon="user"
          iconPosition="left"
          name="email"
          placeholder="Correo electrónico"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Input
          type="password"
          icon="lock"
          iconPosition="left"
          name="password"
          placeholder="Contraseña"
          onChange={formik.handleChange}
          value={formik.values.password}
          error={formik.errors.password}
        />
        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          {" "}
          Entrar{" "}
        </Form.Button>
      </Form>
    </>
  );
}
